import useAppStore from '../store/useAppStore'
import { userApi } from './userApi'

const TELEGRAM_SUPPORT_BOT_URL = 'https://t.me/skinoz_support_bot'
// Минимальный запас жизни подписи me.support (сек): часы устройства могут врать на минуты
const SIGNATURE_MIN_TTL = 300
// Сколько ждём отзыва сессии чата при выходе, чтобы не подвешивать logout
const LOGOUT_TIMEOUT_MS = 3000

let adapterPromise = null
let loginPromise = null
let loginSubject = null

// Адаптер виджета (src/vendor) грузим лениво и только в браузере: он сам подтянет SDK с support.skinoz.net
const loadAdapter = () => {
  if (!adapterPromise) {
    adapterPromise = import('../vendor/skinoz-support-chat.js').then(() => window.SkinozSupportChat)
    adapterPromise.catch(() => { adapterPromise = null })
  }
  return adapterPromise
}

const openTelegramSupport = () => {
  const tg = window.Telegram?.WebApp
  if (useAppStore.getState().runtimeEnvironment === 'telegram' && tg?.openLink) {
    tg.openLink(TELEGRAM_SUPPORT_BOT_URL)
    return
  }

  // После await браузер может заблокировать новую вкладку — тогда открываем бота в текущей
  if (!window.open(TELEGRAM_SUPPORT_BOT_URL, '_blank', 'noopener,noreferrer')) {
    window.location.assign(TELEGRAM_SUPPORT_BOT_URL)
  }
}

// Подпись живёт час: если запас мал, берём свежий блок из GET /api/me/
const getFreshSupport = async (support) => {
  if (support.expires - Math.floor(Date.now() / 1000) >= SIGNATURE_MIN_TTL) {
    return support
  }
  const response = await userApi.getProfile()
  return response?.me?.support
}

// Вход в виджет поддержки блоком me.support без изменений. Повторно для того же subject не вызывается:
// login() адаптера сбрасывает текущую сессию чата
export const loginSupport = (support) => {
  if (!support?.subject) {
    return Promise.reject(new Error('support_identity_missing'))
  }
  if (loginPromise && loginSubject === support.subject) {
    return loginPromise
  }

  loginSubject = support.subject
  const promise = (async () => {
    const freshSupport = await getFreshSupport(support)
    const chat = await loadAdapter()
    await chat.login({ me: { support: freshSupport } })
  })()
  loginPromise = promise
  promise.catch((error) => {
    console.error('Ошибка входа в виджет поддержки:', error)
    // Сбрасываем, чтобы следующее открытие поддержки попробовало войти заново
    if (loginPromise === promise) {
      loginPromise = null
      loginSubject = null
    }
  })
  return promise
}

// Отзыв сессии чата перед выходом из аккаунта
export const logoutSupport = async () => {
  loginPromise = null
  loginSubject = null
  if (!adapterPromise) {
    return
  }

  try {
    const chat = await adapterPromise
    await Promise.race([chat.logout(), new Promise((resolve) => setTimeout(resolve, LOGOUT_TIMEOUT_MS))])
  } catch (error) {
    console.error('Ошибка выхода из виджета поддержки:', error)
  }
}

// В Telegram и для гостей — бот поддержки, в браузере у авторизованного — виджет (при ошибке тоже бот)
export const openSupport = async () => {
  const { runtimeEnvironment, isAuthorized, user } = useAppStore.getState()
  if (runtimeEnvironment !== 'browser' || !isAuthorized || !user?.support) {
    openTelegramSupport()
    return
  }

  try {
    await loginSupport(user.support)
    window.SupportDeskChat.open()
  } catch {
    openTelegramSupport()
  }
}
